import type { LoaderFunctionArgs } from "react-router-dom";
import { redirect } from "react-router-dom";
import { ApolloClient, InMemoryCache } from '@apollo/client';

import { PATHS } from '../../paths';
import { authProvider } from "../../auth";
import { BACKEND_URL } from '../../config';

import { MobileLoginView } from './MobileLoginView';
import { LOGIN_MUATION } from './data/mutation_login'

const client = new ApolloClient({
  uri: BACKEND_URL,
  cache: new InMemoryCache(),
});

function LoginPage() {
  return <MobileLoginView />;
}

async function loginAction({ request }: LoaderFunctionArgs) {
  let formData = await request.formData();
  let username = formData.get("username") as string | null;
  let password = formData.get("password") as string | null;

  // Validate our form inputs and return validation errors via useActionData()
  if (!username) {
    return {
      error: "You must provide a username to log in",
    };
  }

  // Sign in and redirect to the proper destination if successful.
  try {
    const loginRequest = await client.mutate({ mutation: LOGIN_MUATION, variables: { userName: username, password } });
    if (loginRequest.errors) {
      throw new Error();
    }
    if (loginRequest?.data?.login?.token) {
      await authProvider.signin(loginRequest?.data?.login?.token, loginRequest?.data?.login?.refreshToken);
    }
  } catch (error: any) {
    // Unused as of now but this is how you would handle invalid
    // username/password combinations - just like validating the inputs
    // above
    return {
      error: error.toString(),
    };
  }

  client.resetStore() // Clear the Apollo Client cache to ensure no stale data is used

  let redirectTo = formData.get("redirectTo") as string | null;
  return redirect(redirectTo || PATHS.ROOT);
}

async function loginLoader() {
  if (authProvider.isAuthenticated()) {
    return redirect(PATHS.ORGANISATIONS);
  }
  return null;
}

export { LoginPage, loginLoader, loginAction };
